module.exports = __webpack_public_path__ + "img/upA.fc70661c.png";